const foodOperatorEnumerators = {
  country: [
    'default',
  ],
  operatorType: [
    'produced_by',
    'imported_by',
    'bottled_by',
    'packed_by',
  ],
};

export default foodOperatorEnumerators;
